import { makeStyles, Theme } from '@material-ui/core/styles';

export function useEMSModalStyles() {
    const useStyles = makeStyles((theme: Theme) => ({
        titleRoot: {
            '&.MuiDialogTitle-root > h2': {
                fontSize: '1.4rem',
                fontWeight: 600,
                color: '#000',
                textAlign: 'center',
                textTransform: 'initial',
            }
        },
        content: {
            color: 'gray',
            padding: '1.5rem 3rem',
            fontSize: '1.2rem',
        },
        footer: {
            padding: '1.5rem 3rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5rem',
        },
        link: {
            color: 'gray',
            textWrap: 'nowrap',
        },
        linkButton: {
            flex: 1,
            textAlign: 'center',
            textDecoration: 'underline',
            color: '#1976d2',
            fontSize: '1.2rem',
            fontWeight: 600,
            '&:hover': {
                color: '#115293',
                textDecoration: 'underline',
            },
        },
        closeButton: {
            flex: 1,
            borderRadius: '0',
            fontSize: '1.2rem',
            fontWeight: 600,
            backgroundColor: '#1976d2',
            color: '#fff',
            '&:hover': {
                backgroundColor: '#115293',
            },
        }
    }));
    const classes = useStyles();

    return {
        classes
    }
}